
import {
    ADD_OPERATION_ITEM,
    ADD_USEK,
    CLEAR,
    CLEAR_READ_FILE,
    CHANGE_USEK_ID,
    DELETE_OPERATION_ITEM,
    DELETE_USEK,
    EDIT_USEK,
    PROJECT_ACTION_TYPE,
    READ_PRICELIST,
    READ_PROJECT,
    SET_CALCULATION_OPERATION,
    SET_ERROR_MESSAGE,
    SET_INPUT_TYPE,
    SET_MAP_CONTENT,
    SET_PRICELIST_TITLE,
    SET_PRICELIST_TYPE,
    SET_USEK_ATTRIBUTE,
    UPDATE_OPERATION_ITEM,
    USE_PRICELIST_DATA,
    USE_PRICELIST_FOR_CALCULATION,
    USE_READED_ITEMS
} from '../sagas/project';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

export const INPUT_TYPE_FILE = 'FILE';
export const INPUT_TYPE_DRAW = 'DRAW';
export const INPUT_TYPE_PROJECT = 'PROJECT';

export const PRICELIST_TYPE_DEFAULT = 'DEFAULT';
export const PRICELIST_TYPE_FILE = 'FILE';
export const PRICELIST_TYPE_EDIT_DEFAULT = 'EDIT_DEFAULT';
export const PRICELIST_TYPE_CUSTOM = 'CUSTOM';

const initialState = {
    ...loaderInitialState,
    calculationOperations: [],
    inputType: null,
    mapContent: null,
    pricelistData: null,
    pricelistReadOnly: false,
    pricelistType: null,
    readFileResult: null,
    usekMezAttributes: {},
    usekMezItems: null,
    errorMessage: null
};

function existsOperationItemId(id, operationItems) {
    return operationItems.reduce((previous, current) => {
        return (current.id === id) ? true : previous;
    }, false);
}

function generateOperationItemId(opId, operationItems) {
    let id;
    let num = 1;
    let isOk = false;
    while (!isOk) {
        id = `${opId}_${num}`;
        if (!existsOperationItemId(id, operationItems)) {
            isOk = true;
        } else {
            num++;
        }
    }
    return id;
}

function addOperationItem(state, action) {
    let items = (state.pricelistData && state.pricelistData.items)
        ? state.pricelistData.items
        : [];
    return {
        ...state,
        pricelistData: {
            ...state.pricelistData,
            items: [
                ...items,
                {
                    id: generateOperationItemId(action.opId, items),
                    opId: action.opId,
                    title: action.title,
                    price: action.price
                }
            ]
        }
    };
}

function addUsek(state, action) {
    return {
        ...state,
        usekMezItems: [
            ...(state.usekMezItems || []),
            action.item
        ]
    };
}

function clear(state, action) {
    return {
        ...initialState
    };
}

function clearReadFileResult(state, action) {
    return {
        ...state,
        readFileResult: null
    };
}

function changeUsekId(state, action) {
    return {
        ...state,
        usekMezItems: [
            ...(state.usekMezItems || []).map(item => {
                return (item.properties['id_usek'] === action.id_usek_old)
                    ? {
                        ...item,
                        properties: {
                            ...item.properties,
                            id_usek: action.id_usek_new
                        }
                    }
                    : item;
            })
        ]
    };
}

function deleteOperationItem(state, action) {
    return {
        ...state,
        pricelistData: {
            ...state.pricelistData,
            items: state.pricelistData.items.filter(item => {
                return (item.id !== action.id);
            })
        }
    };
}

function deleteUsek(state, action) {
    return {
        ...state,
        usekMezItems: state.usekMezItems.filter(item => {
            return (item.properties['id_usek'] !== action.id_usek)
        })
    };
}

function editUsek(state, action) {
    return {
        ...state,
        usekMezItems: [
            ...(state.usekMezItems || []).map(item => {
                return (item.properties['id_usek'] === action.item.id_usek)
                    ? {
                        ...item,
                        geometry: action.item.geometry
                    }
                    : item;
            })
        ]
    };
}

export function getCalculationOperations(state) {
    return state.calculationOperations;
}

export function getErrorMessage(state) {
    return state.errorMessage;
}

export function getLoading(state) {
    return state.loading;
}

export function getInputType(state) {
    return state.inputType;
}

export function getMapContent(state) {
    return state.mapContent;
}

export function getPricelistData(state) {
    return state.pricelistData;
}

export function getPricelistReadOnly(state) {
    return state.pricelistReadOnly;
}

export function getPricelistType(state) {
    return state.pricelistType;
}

export function getPricelistSaveData(state) {
    return JSON.stringify({
        type: 'MEZCALC_PRICELIST',
        ...state.pricelistData
    });
}

export function getProjectSaveData(state) {
    return JSON.stringify({
        type: 'MEZCALC_PROJECT',
        calculationOperations: state.calculationOperations,
        inputType: state.inputType,
        pricelistData: state.pricelistData,
        pricelistReadOnly: state.pricelistReadOnly,
        pricelistType: state.pricelistType,
        usekMezItems: state.usekMezItems,
        usekMezAttributes: state.usekMezAttributes
    });
}

export function getReadFileResult(state) {
    return state.readFileResult;
}

export function getUsekMezAttributes(state, usekId) {
    return (usekId)
        ? state.usekMezAttributes[usekId] || {}
        : state.usekMezAttributes;
}

export function getUsekMezItems(state) {
    return state.usekMezItems;
}

function parseJson(content) {
    let json;
    try {
        json = JSON.parse(content);
    }
    catch (e) {
        // nop;
    }
    return json;
}

function readPricelist(state, action) {
    const json = parseJson(action.content);
    return (json && ((json.type === 'MEZCALC_PRICELIST') || (json.title && json.items)))
        ? {
            ...state,
            pricelistData: {
                title: json.title,
                items: json.items
            },
            pricelistReadOnly: false
        }
        : {
            ...state,
            pricelistData: null,
            errorMessage: 'Soubor s ceníkem je ve špatném formátu'
        };
}

function readProject(state, action) {
    const json = parseJson(action.content);
    return (json && (json.type === 'MEZCALC_PROJECT'))
        ? {
            ...initialState,
            calculationOperations: {
                ...(json.calculationOperations || {})
            },
            inputType: INPUT_TYPE_PROJECT,
            pricelistData: json.pricelistData,
            pricelistReadOnly: (json.pricelistReadOnly === true),
            pricelistType: json.pricelistType,
            usekMezItems: [
                ...(json.usekMezItems || [])
            ],
            usekMezAttributes: {
                ...(json.usekMezAttributes || {})
            }
        }
        : {
            ...state,
            errorMessage: 'Soubor s projektem je ve špatném formátu'
        };
}

function readFileResult(state, action) {
    return {
        ...state,
        readFileResult: action.data.result
    };
}

function setCalculationOperation(state, action) {
    return {
        ...state,
        calculationOperations: {
            ...state.calculationOperations,
            [`${action.usekId}_${action.opId}`]: {
                opId: action.opId,
                itemId: action.itemId,
                pricePerUnit: action.pricePerUnit
            }
        }
    };
}

function setErrorMessage(state, action) {
    return {
        ...state,
        errorMessage: action.errorMessage
    };
}

function setMapContent(state, action) {
    return {
        ...state,
        mapContent: action.mapContent
    };
}

function setUsekAttribute(state, action) {
    return {
        ...state,
        usekMezAttributes: {
            ...state.usekMezAttributes,
            [action.usekId]: {
                ...(state.usekMezAttributes[action.usekId] || {}),
                [action.name]: action.value
            }
        }
    };
}

function setInputType(state, action) {
    return {
        ...state,
        inputType: action.inputType
    };
}

function setPricelistTitle(state, action) {
    return {
        ...state,
        pricelistData: {
            ...state.pricelistData,
            title: action.title
        }
    };
}

function setPricelistType(state, action) {
    return {
        ...state,
        pricelistType: action.pricelistType
    };
}

function updateOperationItem(state, action) {
    return {
        ...state,
        pricelistData: {
            ...state.pricelistData,
            items: state.pricelistData.items.map(item => {
                return (item.id === action.id)
                    ? {
                        ...item,
                        title: action.title,
                        price: action.price
                    }
                    : item;
            })
        }
    };
}

function usePricelistData(state, action) {
    return {
        ...state,
        pricelistData: action.data,
        pricelistReadOnly: action.readOnly
    };
}

function usePricelistForCalculation(state, action) {
    let items = {}

    const existsOperationItem = (operationItemId) => {
        return state.pricelistData.items.reduce((previous, current) => {
            return (current.id === operationItemId)
                ? true
                : previous;
        }, false);
    }

    for (let name in state.calculationOperations) {
        let item = state.calculationOperations[name];
        if (existsOperationItem(item.itemId)) {
            items[name] = item;
        }
    }

    return {
        ...state,
        calculationOperations: items
    }
}

function useReadedItems(state, action) {
    return {
        ...state,
        usekMezItems: [
            ...state.readFileResult.items
        ]
    };
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(PROJECT_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case ADD_OPERATION_ITEM:
                return addOperationItem(state, action);

            case ADD_USEK:
                return addUsek(state, action);

            case CLEAR:
                return clear(state, action);

            case CLEAR_READ_FILE:
                return clearReadFileResult(state, action);

            case CHANGE_USEK_ID:
                return changeUsekId(state, action);

            case DELETE_OPERATION_ITEM:
                return deleteOperationItem(state, action);

            case DELETE_USEK:
                return deleteUsek(state, action);

            case EDIT_USEK:
                return editUsek(state, action);

            case READ_PRICELIST:
                return readPricelist(state, action);

            case READ_PROJECT:
                return readProject(state, action);

            case SET_CALCULATION_OPERATION:
                return setCalculationOperation(state, action);

            case SET_ERROR_MESSAGE:
                return setErrorMessage(state, action);

            case SET_INPUT_TYPE:
                return setInputType(state, action);

            case SET_MAP_CONTENT:
                return setMapContent(state, action);

            case SET_PRICELIST_TITLE:
                return setPricelistTitle(state, action);

            case SET_PRICELIST_TYPE:
                return setPricelistType(state, action);

            case SET_USEK_ATTRIBUTE:
                return setUsekAttribute(state, action);

            case UPDATE_OPERATION_ITEM:
                return updateOperationItem(state, action);

            case USE_PRICELIST_DATA:
                return usePricelistData(state, action);

            case USE_PRICELIST_FOR_CALCULATION:
                return usePricelistForCalculation(state, action);

            case USE_READED_ITEMS:
                return useReadedItems(state, action);

            case PROJECT_ACTION_TYPE.SUCCESS:
                switch (action.data?.result?.operation) {
                    case 'READ_FILE':
                        state = readFileResult(state, action);
                        break;
                    default:
                        console.warn(`Bad operation result: '${action.data?.result?.operation}'`)
                        break;
                }
                return loaderReducer(state, action);

            default:
                return loaderReducer(state, action);
        }
    };
}
